import { Container } from 'react-bootstrap';
import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { OrganizationEditOrganism, TranslationOrganism } from '../../organisms';
import { BuyerResponseDto } from '../../../store/buyerAPI/buyer/dto/response/buyer-response.dto';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import OrganizationBaseEditTemplate from '../../../templates/OrganizationBaseEditTemplate';
import { PromiseSettledResult } from '../../../utils/types/types';

interface OrganizationEditTemplateProps {
  data: BuyerResponseDto;
  handleOnChange: (data: BuyerResponseDto) => void;
  onSubmit: (data: BuyerResponseDto) => void;
  handleBackgroundOnChange: (imageMeta: ImageMeta) => void;
  handleLogoOnChange: (logoMeta: ImageMeta) => void;
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const OrganizationEditTemplate: FC<OrganizationEditTemplateProps> = ({
  data,
  handleOnChange,
  onSubmit,
  handleBackgroundOnChange,
  handleLogoOnChange,
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <OrganizationBaseEditTemplate>
          <TranslationOrganism
            setLanguage={setLanguage}
            selectedLanguage={selectedLanguage}
            fromLanguage={fromLanguage}
            setFromLanguage={setFromLanguage}
            toLanguage={toLanguage}
            setToLanguage={setToLanguage}
            generateTranslation={generateTranslation}
            generateAllTranslations={generateAllTranslations}
          />
          <OrganizationEditOrganism
            handleOnChange={handleOnChange}
            data={data}
            onSubmit={onSubmit}
            handleBackgroundOnChange={handleBackgroundOnChange}
            handleLogoOnChange={handleLogoOnChange}
          />
        </OrganizationBaseEditTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default OrganizationEditTemplate;
